import { InAppReview } from '@capacitor-community/in-app-review';
import { Capacitor } from '@capacitor/core';

const STORAGE_KEY = 'bullivo.reviewPrompter.v1';
const SIGNAL_THRESHOLD = 3;
const COOLDOWN_DAYS = 120;

function loadState() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return { signalsViewed: 0, lastPrompt: 0, dismissed: false };
    return JSON.parse(raw);
  } catch {
    return { signalsViewed: 0, lastPrompt: 0, dismissed: false };
  }
}

function saveState(s) {
  try { localStorage.setItem(STORAGE_KEY, JSON.stringify(s)); } catch {}
}

function shouldPrompt(state) {
  if (state.dismissed) return false;
  if (state.signalsViewed < SIGNAL_THRESHOLD) return false;
  const now = Date.now();
  const cooldownMs = COOLDOWN_DAYS * 24 * 60 * 60 * 1000;
  if (state.lastPrompt && now - state.lastPrompt < cooldownMs) return false;
  return true;
}

export function trackSignalView() {
  const s = loadState();
  s.signalsViewed = (s.signalsViewed || 0) + 1;
  saveState(s);
  if (shouldPrompt(s) && Capacitor.getPlatform() === 'ios') {
    setTimeout(() => requestReview(), 1200);
  }
}

async function requestReview() {
  const s = loadState();
  s.lastPrompt = Date.now();
  saveState(s);
  try {
    await InAppReview.requestReview();
  } catch (err) {
    console.warn('InAppReview failed:', err);
  }
}

export function dismissReviewPrompts() {
  const s = loadState();
  s.dismissed = true;
  saveState(s);
}
